"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        display: 'block',
        fill: 'currentColor',
        width: '100%',
        height: 'auto',
        transition: 'color 100ms linear 0ms',
        transform: 'rotate(45deg)'
    }
};
//# sourceMappingURL=uicon.link.horizontal.style.js.map